import { inject, InjectionToken } from '@angular/core';

import { map, Observable, shareReplay } from 'rxjs';

import { SHARE_REPLAY_SETTINGS } from '@bazis/configuration.service';

import { BAZIS_WINDOW_SIZES } from './window-sizes.token';

export enum BazisDeviceOrientation {
    Portrait = 'portrait',
    Landscape = 'landscape',
}

export const BAZIS_DEVICE_ORIENTATION = new InjectionToken<Observable<BazisDeviceOrientation>>(
    'BAZIS_DEVICE_ORIENTATION',
    {
        providedIn: 'root',
        factory: () =>
            inject(BAZIS_WINDOW_SIZES).pipe(
                map(({ width, height }) =>
                    width >= height
                        ? BazisDeviceOrientation.Portrait
                        : BazisDeviceOrientation.Landscape,
                ),
                shareReplay(SHARE_REPLAY_SETTINGS),
            ),
    },
);
